import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { Link } from 'react-router-dom';

const SuccessModal = ({ isVisible, memberData, onClose, onAddAnother }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-lg shadow-deep max-w-md w-full">
        <div className="p-6 text-center">
          {/* Success Icon */}
          <div className="w-16 h-16 bg-success rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="Check" size={32} color="white" />
          </div>
          
          {/* Success Message */}
          <h3 className="text-xl font-semibold text-foreground mb-2">
            Membro cadastrado com sucesso!
          </h3>
          
          <p className="text-muted-foreground mb-6">
            {memberData?.fullName} foi adicionado à base de filiados.
          </p>
          
          {/* Member Details Summary */}
          <div className="bg-muted rounded-lg p-4 mb-6 text-left">
            <h4 className="font-medium text-foreground mb-2">Detalhes do membro:</h4>
            <div className="space-y-1 text-sm">
              <p><span className="font-medium">Nome:</span> {memberData?.fullName}</p>
              <p><span className="font-medium">CPF:</span> {memberData?.cpf}</p>
              <p><span className="font-medium">Título de eleitor:</span> {memberData?.voterId}</p>
              <p><span className="font-medium">E-mail:</span> {memberData?.emails?.[0]?.address}</p>
            </div>
          </div>
          
          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              variant="outline"
              onClick={onAddAnother}
              fullWidth
              iconName="UserPlus"
              iconPosition="left"
            >
              Adicionar outro membro
            </Button>
            
            <Link to="/member-list" className="flex-1">
              <Button
                variant="default"
                onClick={onClose}
                fullWidth
                iconName="Users"
                iconPosition="left"
              >
                Ver todos os membros
              </Button>
            </Link>
          </div>
          
          <div className="mt-4">
            <Link to="/member-dashboard">
              <Button
                variant="ghost"
                size="sm"
                iconName="BarChart3"
                iconPosition="left"
              >
                Ir para o painel
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;